enum ReservationEventType {
  ReservationActivated = 'ReservationActivated',
  ReservationActivatedSMS = 'ReservationActivatedSMS',
  ReservationDeactivated = 'ReservationDeactivated',
  ReservationDrafted = 'ReservationDrafted',
  ReservationCanceled = 'ReservationCanceled',
}

type ReservationEventDetail = {
  clientBC: string;
  correlationUUID: string;
  createdByUserID: string;
  createdDateTimeUTC: string;
  isInternal: boolean;
  modifiedByUserID: string;
  modifiedDateTimeUTC: string;
  modifiedOnUTC: string;
  passengerUUID: string;
  reservationReferenceID: string;
  reservationServiceDate: string;
  state: string;
};

type ReservationEventDetailSMS = ReservationEventDetail & {
  id: string;
  websocketStatus: string;
};

export {
  ReservationEventType,
  type ReservationEventDetail,
  type ReservationEventDetailSMS,
};
